import { Injectable } from "@angular/core";
import { SelectiveCartService } from "@spartacus/cart/base/core";

@Injectable()
export class ValioSelectiveCartService extends SelectiveCartService {


}
